import { REHYDRATE } from 'redux-persist';

const defaults: State = {
  data: {
    sourceType: [],
    orderType: [],
    revenueCenter: [],
    sensorGrpTypes: [],
    activeNotificationFilter: 'sourceType',
  },
};

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: State = defaults, action: ActionType) => {
  switch (action.type) {
    case 'UPDATE_NOTIFICATION_TYPES': {
      return { ...state, data: { ...action.payload } };
    }
    case REHYDRATE: {
      if (
        action.payload &&
        action.payload.notificationsTypesPersist &&
        action.payload.notificationsTypesPersist.data
      ) {
        return { ...state, ...action.payload.notificationsTypesPersist };
      }
      return { ...defaults };
    }
    default:
      return state;
  }
};
